
import {
  defineComponent,
  ref,
  onMounted,
} from 'vue';

export default defineComponent({
  setup() {
    const solar = ref();
    const wind = ref();
    const erin = ref();
    const hero = ref();

    const {
      ioappConfig: {
        themeUri,
      },
    } = window;

    onMounted(() => {
      if (solar.value) {
        solar.value.style.backgroundImage = `url('${themeUri}/assets/img/hero/CASKlimahelden - Solaranlage.svg')`;
      }
      if (wind.value) {
        wind.value.style.backgroundImage = `url('${themeUri}/assets/img/hero/CASKlimahelden - Windrad.svg')`;
      }
      if (erin.value) {
        erin.value.style.backgroundImage = `url('${themeUri}/assets/img/hero/CASKlimahelden - Erin Turm.svg')`;
      }
      if (hero.value) {
        hero.value.style.backgroundImage = `url('${themeUri}/assets/img/hero/Stw Castrop-Rauxel - Klimahelden Kampagne - Superman.svg')`;
      }
    });

    return {
      solar,
      wind,
      erin,
      hero,
    };
  },
});
